module.exports = __webpack_public_path__ + "img/p2.f24c5cd1.png";